'use client'

import Image from 'next/image'
import { useTranslations } from 'next-intl'

import S from './ForClubsRevenueModel.module.scss'

const ForClubsRevenueModel = () => {
  const t = useTranslations('forClubsPage.revenueModel')

  const steps = [
    {
      index: t('step1Index'),
      title: t('step1Title'),
      description: t('step1Description')
    },
    {
      index: t('step2Index'),
      title: t('step2Title'),
      description: t('step2Description')
    },
    {
      index: t('step3Index'),
      title: t('step3Title'),
      description: t('step3Description')
    }
  ]

  return (
    <section className={S.revenueSection}>
      <div className={S.sectionBackground}>
        <div className={S.revenueGrain} aria-hidden />
        <div className={S.backgroundImageWrapper}>
          <Image
            src="/assets/forClubs/revenue-bg.png"
            alt="Revenue Model Background"
            fill
            className={S.backgroundImage}
            sizes="1440px"
            priority
          />
        </div>
        <div className={S.backgroundMask} aria-hidden="true">
          <svg
            viewBox="0 0 1440 823"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            className={S.maskSvg}
          >
            <defs>
              <radialGradient
                id="bgMaskGrad"
                gradientUnits="userSpaceOnUse"
                cx="0"
                cy="0"
                r="10"
                gradientTransform="matrix(4.4087e-15 41.15 -72 2.5197e-15 720 411.5)"
              >
                <stop stopColor="rgba(16,16,20,0)" offset="0" />
                <stop stopColor="rgba(16,16,20,1)" offset="1" />
              </radialGradient>
            </defs>
            <rect
              x="0"
              y="0"
              width="100%"
              height="100%"
              fill="url(#bgMaskGrad)"
            />
          </svg>
        </div>
      </div>

      <p className={S.sectionEyebrow}>{t('eyebrow')}</p>
      <h2 className={S.sectionTitle}>{t('headline')}</h2>

      <div className={S.pointsList}>
        {steps.map(step => (
          <div key={step.index} className={S.pointsRow}>
            <p className={S.pointsIndex}>{step.index}</p>
            <p className={S.pointsTitle}>{step.title}</p>
            <p className={S.pointsDescription}>{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default ForClubsRevenueModel
